import {Status, StatusColor, MMSubStatus} from 'types';

export const mapStatusColor: Record<Status, StatusColor> = {
  new: 'default',
  processing: 'default',
  processed: 'default',
  awaiting: 'default',
  active: 'default',
  cancelled: 'gray',
  canceled: 'gray',
  in_progress: 'iris_dark',
  invalid: 'iris',
  completed: 'green',
  incomplete: 'gray',
  ready_for_dispatch: 'fuschia',
  call_doctor: 'fuschia',
};

export const mapMMSubStatusColor: Record<MMSubStatus, StatusColor> = {
  completed: 'green',
  waiting_for_pickup: 'yellow',
  billed: 'iris',
  unbilled: 'iris_light',
  paid: 'iris',
  filled: 'iris_light',
  in_progress: 'yellow',
  otc_status: 'default',
  new: 'default',
  delivered: 'green',
  ready_for_delivery: 'iris_dark',
  ready_for_dispatch: 'iris_light',
  canceled: 'canceled',
  picked_up: 'green',
  delivery_partner: 'iris',
  archived: 'gray',
};

export const mapStatusText: Record<Status, string> = {
  new: 'New',
  in_progress: 'In progress',
  invalid: 'Invalid',
  processing: 'default',
  processed: 'default',
  cancelled: 'default',
  canceled: 'default',
  awaiting: 'default',
  active: 'default',
  completed: 'Closed',
  incomplete: 'Incomplete',
  call_doctor: 'Call doctor',
  ready_for_dispatch: 'Ready for dispatch',
};
export const mapMMStatusText: Record<MMSubStatus, string> = {
  completed: 'Completed',
  billed: 'Billed',
  unbilled: 'Unbilled',
  paid: 'Paid',
  filled: 'Filled',
  in_progress: 'In progress',
  new: 'New',
  otc_status: 'OTC CheckOut',
  ready_for_delivery: 'Ready for delivery',
  ready_for_dispatch: 'Ready for dispatch',
  waiting_for_pickup: 'Waiting for Pickup',
  delivered: 'Delivered',
  picked_up: 'Picked Up',
  canceled: 'Skipped',
  delivery_partner: 'Delivery Partner',
  archived: 'Archived',
};
